import { createFileRoute, redirect } from '@tanstack/react-router'
import Loader from '@/components/common/Loader'
import { lazy, Suspense } from 'react'

const RolesAndPermissionsFormPage = lazy(async () => {
  const module = await import(
    '@/features/city-clerk/roles-and-permissions/pages/RolesAndPermissionsFormPage/RolesAndPermissionsFormPage'
  )
  return { default: module.default }
})

export const Route = createFileRoute(
  '/(app)/city-clerk/roles-and-permissions/$roleId',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.rolesPermissionsManage) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { roleId } = Route.useParams()
  return (
    <Suspense
      fallback={
        <div className="h-page flex items-center justify-center">
          <Loader size="lg" />
        </div>
      }
    >
      <RolesAndPermissionsFormPage mode="edit" roleId={roleId} />
    </Suspense>
  )
}
